<template>
  <div class="sctool-color" v-drag style="cursor: move;">
    <div class="sctool-history">
      <p class="sctool-history-tit">历史记录</p>
      <ul id="recordColor">
        <li
          v-for="(color,key) in history"
          :key="key"
          :style="{backgroundColor: color }"
          :data-color="color"
          @click="checkColor(color)"
        >
          <i
            class="fa checked-color"
            aria-hidden="true"
            style="color: white;font-size: 16px;position: absolute;top: 2px;left: 2px;"
          ></i>
        </li>
        <li class="sctool-history-dele" @click="clear_history">
          <i class="fa fa-trash-o" aria-hidden="true"></i>
          <span>清空</span>
          <b></b>
        </li>
        <br clear="all">
      </ul>
    </div>
    <div class="sctool-library">
      <p class="sctool-library-tit">推荐颜色</p>
      <ul>
        <li class="custom-color">
          <el-color-picker @change="changeCustomColor" v-model="customColor" show-alpha></el-color-picker>
        </li>
        <li
          v-for="(item,key) in items[cardIdx]"
          :key="key"
          :style="{backgroundColor: item }"
          :data-color="item"
          @click="checkColor(item)"
        >
          <i
            class="fa checked-color"
            aria-hidden="true"
            style="color: white;font-size: 16px;position: absolute;top: 2px;left: 2px;"
          ></i>
        </li>
        <li class="sctool-library-dele" @click="systemChange()">
          <i class="fa fa-refresh" aria-hidden="true"></i>
          <span>换一批</span>
          <b></b>
        </li>
        <br clear="all">
      </ul>
    </div>
    <div class="sctool-transparent">
      <el-slider
        v-model="valueOpacity"
        :step="1"
        :min="0"
        :max="100"
        @blur="change_color_fn()"
        @change="change_color_fn()"
      ></el-slider>
    </div>
    <div class="sctool-input-color">
      <p class="sctool-input-color-p1" :style="{backgroundColor:colorVal}"></p>
      <p class="sctool-input-color-p2">#</p>
      <el-input class="input" @change="colorInputFn" v-model="colorInputVal" placeholder="请输入内容"></el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: "color",
  data() {
    return {
      customColor: 'rgba(19, 206, 102, 0.8)',
      items: [
        [
          "#ffdfe1",
          "#f9c3cd",
          "#efa9a9",
          "#f597ab",
          "#ed8ba5",
          "#f17c83",
          "#f5a7b9",
          "#e97a91",
          "#d1104c",
          "#faf5dd",
          "#fff7db",
          "#f9e9c1",
          "#fadf70",
          "#ffd71a",
          "#e5bf10",
          "#fdd316",
          "#dfc342",
          "#f4bf4c",
          "#b78b26",
          "#f7dfb5",
          "#f5e37a",
          "#fcb500",
          "#f7c172",
          "#f3bd81",
          "#e0c99d",
          "#f7dfb5",
          "#ebc926",
          "#e3c79b",
          "#e5bd3a",
          "#adffcb",
          "#91f7d7",
          "#6affdf",
          "#00ffe5",
          "#22f306",
          "#9bbb87",
          "#bfd72e",
          "#b7e13a",
          "#76bb38",
          "#4e8b20",
          "#bde7f3",
          "#8bd7e5",
          "#70cfe3",
          "#a3dbe9",
          "#0eb1c9",
          "#22a3c3",
          "#66a9c9"
        ],
        [
          "#ff9100",
          "#875646",
          "#87463e",
          "#543826",
          "#262e38",
          "#ff5432",
          "#f97852",
          "#566487",
          "#a5662c",
          "#818b8f",
          "#c9c1a7",
          "#3c6897",
          "#084074",
          "#124630",
          "#2e2e34",
          "#edf2fb",
          "#f5b170",
          "#c31c46",
          "#c5141c",
          "#626c7a",
          "#c9c7a1",
          "#32a3b1",
          "#26709d",
          "#206c22",
          "#4e5646",
          "#a78d70",
          "#585a4e",
          "#ff7c14",
          "#8781a3",
          "#d54a28",
          "#523a4a",
          "#56242a",
          "#403836",
          "#382426",
          "#32282e",
          "#d974a3",
          "#ed895e",
          "#9783b7",
          "#971212",
          "#c9466c",
          "#64363c",
          "#34705a",
          "#cb4a64",
          "#203048",
          "#060000",
          "#d54444"
        ]
      ],
      cardIdx: 0,
      history: new Set(),
      valueOpacity: 100,
      colorInputVal: "",
      colorVal: ""
    };
  },
  props: {
    value: {
      type: String,
      default: "#000001"
    }
  },
  methods: {
    //色盘 => 滑块 颜色透明度
    change_color_fn() {
      try {
        let c = hexToRgba(rgb2hex(this.colorVal), this.valueOpacity / 100);
        this.setColorData(c, this.colorVal);
        this.setColorInputVal(c);
      } catch (error) {
        console.log(error);
      }
    },
    //更新数据色值=>
    setColorData(newColor, oldColor) {
      console.log(newColor);
      this.$emit("upColor", newColor);
      this.colorVal = newColor;
    },
    //更新色盘输入框值
    setColorInputVal(color) {
      let hex = rgb2hex(color);
      this.colorInputVal = hex.substring(1, hex.length);
    },
    changeCustomColor(){
      this.setColorData(this.customColor);
      this.history.add(this.customColor);
    },
    //切换色盘
    systemChange() {
      if (this.cardIdx >= this.items.length - 1) {
        this.cardIdx = 0;
      } else {
        this.cardIdx++;
      }
    },
    //色盘输入框
    colorInputFn() {
      this.pushHistory(`#${this.colorInputVal}`);
      let c = hexToRgba(`#${this.colorInputVal}`, this.valueOpacity / 100);
      this.setColorData(c, this.colorVal);
    },
    pushHistory(color) {
      this.history.add(color);
    },
    //色盘 => 更换颜色
    checkColor(color) {
      try {
        let c = hexToRgba(color, this.valueOpacity / 100);
        this.setColorData(c, this.colorVal);
        this.setColorInputVal(c);
        this.pushHistory(`#${this.colorInputVal}`);
      } catch (error) {
        console.log(error);
      }
    },
    //清空颜色记录
    clear_history() {
      this.history = new Set();
    }
  },
  mounted() {
    this.colorVal = this.value;
    this.setColorInputVal(this.colorVal);
  },
  watch: {
    value(newVal, oldVal) {
      this.colorVal = newVal;
      this.setColorInputVal(this.colorVal);
    }
  }
};
</script>

<style lang="scss">
.sctool-color,
.sctool-color2 {
  box-shadow: 0 0 3px #aaa;
  color: #888;
  position: absolute;
  left: -178px;
  width: 170px;
  background-color: #fff;
  top: 0;
  border-radius: 5px;
  padding: 6px 10px 14px;
  box-sizing: border-box;
}
.sctool-color .sctool-history,
.sctool-color2 .sctool-history {
  width: 156px;
  margin: 0 auto;
  pointer-events: none;
}
.sctool-color .sctool-history-tit,
.sctool-color2 .sctool-history-tit {
  width: 150px;
  margin: 0 auto;
  font-size: 12px;
  line-height: 26px;
}
.sctool-color .sctool-history ul,
.sctool-color2 .sctool-history ul {
  min-height: 40px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 2px;
}
.sctool-color .sctool-history ul li,
.sctool-color2 .sctool-history ul li {
  width: 20px;
  height: 20px;
  border-radius: 3px;
  margin: 3px 3px;
  cursor: pointer;
  float: left;
  pointer-events: initial;
  position: relative;
}
.sctool-color .sctool-history ul li:hover,
.sctool-color2 .sctool-history ul li:hover {
  box-shadow: 0 0 3px #aaa;
}
.sctool-color .sctool-history-dele,
.sctool-color2 .sctool-history-dele {
  // background-color: #535353 !important;
  font-size: 18px;
  text-align: center;
  line-height: 20px;
  color: #bbb;
  position: relative;
}
.fa-refresh:before {
  content: "";
  width: 20px;
  height: 20px;
  display: block;
  color: #bdbbbb;
  background: url("../assets/images/refresh.png") no-repeat center;
  background-size: 100% 100%;
}
.sctool-color .sctool-history-dele:hover,
.sctool-color2 .sctool-history-dele:hover {
  box-shadow: 0 0 0 #aaa !important;
}
.sctool-color .sctool-history-dele:hover i,
.sctool-color2 .sctool-history-dele:hover i {
  color: #f45858;
}
.fa-trash-o:before {
  content: "";
  width: 20px;
  height: 20px;
  display: block;
  color: #bdbbbb;
  background: url("../assets/images/clearColor.png") no-repeat center;
  background-size: 100% 100%;
}
.sctool-color .sctool-history-dele span,
.sctool-color2 .sctool-history-dele span {
  display: none;
  color: #999;
  border-radius: 2px;
  text-align: center;
  position: absolute;
  bottom: 24px;
  font-size: 12px;
  width: 46px;
  height: 20px;
  line-height: 20px;
  background-color: #ddd;
  left: -12px;
}
.sctool-color .sctool-history-dele b,
.sctool-color2 .sctool-history-dele b {
  display: none;
  position: absolute;
  left: 2px;
  bottom: 18px;
  border-top: 8px solid #ddd;
  border-right: 8px solid transparent !important;
  border-bottom: 0 solid transparent !important;
  border-left: 8px solid transparent !important;
  width: 0;
}
.sctool-color .sctool-history-dele:hover span,
.sctool-color2 .sctool-history-dele:hover span {
  display: block;
}
.sctool-color .sctool-history-dele:hover b,
.sctool-color2 .sctool-history-dele:hover b {
  display: block;
}
.sctool-color .sctool-library,
.sctool-color2 .sctool-library {
  width: 156px;
  margin: 10px auto 0;
}
.sctool-color .sctool-library-tit,
.sctool-color2 .sctool-library-tit {
  width: 150px;
  margin: 0 auto;
  font-size: 12px;
  line-height: 26px;
  height: 26px;
}
.sctool-color .sctool-library-tit .sctool-sp1,
.sctool-color2 .sctool-library-tit .sctool-sp1 {
  float: left;
  cursor: pointer;
}
.sctool-color .sctool-library-tit .sctool-sp1:hover,
.sctool-color2 .sctool-library-tit .sctool-sp1:hover {
  color: #333;
}
.sctool-color .sctool-library-tit .sctool-sp2,
.sctool-color2 .sctool-library-tit .sctool-sp22 {
  float: right;
  cursor: pointer;
}
.sctool-color .sctool-library-tit .sctool-sp2:hover,
.sctool-color2 .sctool-library-tit .sctool-sp22:hover {
  color: #333;
}
.sctool-color .sctool-color2 .sctool-library ul {
  background-color: #535353;
  padding: 10px 0 10px 10px;
  box-sizing: border-box;
}
.sctool-color .sctool-library ul li,
.sctool-color2 .sctool-library ul li {
  width: 20px;
  height: 20px;
  float: left;
  border-radius: 3px;
  margin: 3px 3px;
  cursor: pointer;
  position: relative;
}
.sctool-color .sctool-library ul li:hover,
.sctool-color2 .sctool-library ul li:hover {
  box-shadow: 0 0 3px #aaa;
}
.sctool-color .sctool-library-dele,
.sctool-color2 .sctool-library-dele {
  // background-color: #535353 !important;
  font-size: 14px;
  text-align: center;
  line-height: 20px;
  color: #bbb;
  position: relative;
}
.sctool-color .sctool-library-dele:hover,
.sctool-color2 .sctool-library-dele:hover {
  box-shadow: 0 0 0 #aaa !important;
}
.sctool-color .sctool-library-dele:hover i,
.sctool-color2 .sctool-library-dele:hover i {
  color: #f45858;
}
.sctool-color .sctool-library-dele span,
.sctool-color2 .sctool-library-dele span {
  display: none;
  color: #999;
  border-radius: 2px;
  text-align: center;
  position: absolute;
  bottom: 24px;
  font-size: 12px;
  width: 46px;
  height: 20px;
  line-height: 20px;
  background-color: #ddd;
  left: -12px;
}
.sctool-color .sctool-library-dele b,
.sctool-color2 .sctool-library-dele b {
  display: none;
  position: absolute;
  left: 2px;
  bottom: 18px;
  border-top: 8px solid #ddd;
  border-right: 8px solid transparent !important;
  border-bottom: 0 solid transparent !important;
  border-left: 8px solid transparent !important;
  width: 0;
}
.sctool-color .sctool-library-dele:hover span,
.sctool-color2 .sctool-library-dele:hover span {
  display: block;
}
.sctool-color
  .sctool-library-dele:hover
  b.sctool-color2
  .sctool-library-dele:hover
  b {
  display: block;
}
.sctool-transparent {
  position: relative;
  background: url("../assets/images/bk.png") repeat-x;
  width: 150px;
  height: 10px;
  margin: 5px auto 0;
}
.sctool-transparent-bg {
  background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0), #f00);
  height: 10px;
  width: 100%;
}
.sctool-transparent p {
  position: absolute;
  width: 12px;
  height: 12px;
  background-color: #f8f8f8;
  border-radius: 50%;
  left: 50%;
  top: -1px;
  cursor: pointer;
  box-sizing: border-box;
  ms-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
  -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
  -o-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
}
.sctool-input-color {
  position: relative;
  height: 22px;
  width: 150px;
  margin: 5px auto 5px;
}
.sctool-input-color-p1 {
  margin-top: 1px;
  height: 20px;
  float: left;
  width: 20px;
  background-color: red;
  box-shadow: 0 0 2px #333;
}
.sctool-input-color-p2 {
  position: absolute;
  left: 30px;
  line-height: 20px;
  top: 1px;
}
.sctool-input-color .input {
  border: 1px solid #ddd;
  float: left;
  height: 20px;
  box-sizing: border-box;
  width: 120px;
  padding: 0 8px 0 15px;
  margin-top: 1px;
  margin-left: 5px;
}
.sctool-input-color-button {
  float: left;
  height: 20px;
  font-size: 12px;
  width: 40px;
  background-color: #535353;
  border: 1px solid #ddd;
  color: #333;
  margin-top: 1px;
  border-radius: 3px;
  margin-left: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/com-color.vue